// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterLinks_root__eDi4y"};